module.exports = __webpack_public_path__ + "img/slim11.aaa4fa52.jpg";